<template>
  <v-card flat>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-toolbar dense flat dark color="primary">
              <v-toolbar-title>
                <span class></span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div>Scheduled Report Name</div>
              <p class="text-h4 text--primary">{{datasourceMailer.name}}</p>
              <template v-for="colName in colNames">
                <div :key="colName">
                  <p class="text--primary"><strong>{{fieldName(colName) | capitalize}}: </strong>{{fieldValue(colName, datasourceMailer)}}</p>
                </div>
              </template>
              <v-data-table
                :headers="attachmentHeaders"
                :items="datasourceMailer.attachments"
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:item.actions="{ item }">
                  <template v-for="(rowAction, index) in actions">
                    <v-tooltip top :key="index">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            medium
                            class="mr-2"
                            @click="executeAction(rowAction.action, item)"
                          >{{ rowAction.icon }}</v-icon>
                        </template>
                        <span>{{ rowAction.title }}</span>
                    </v-tooltip>
                  </template>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { useDatasourceMailerCrud } from './crudComposable'
const { split, prop, path, sortBy } = require('ramda')

export default {
  name: 'show-datasource-mailer',
  setup () {
    const { datasourceMailer, fetch, downloadAttachment } = useDatasourceMailerCrud()
    return {
      datasourceMailer,
      fetch,
      downloadAttachment
    }
  },
  data () {
    return {
      colNames: [
        'name',
        'notes',
        'schedule',
        'schedule_start_on',
        'execution_time',
        'status',
        'recipients',
        'dealer.name',
        'datasource.name',
        'created_at',
        'updated_at'
      ],
      attachmentHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Content Type', value: 'content_type' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Actions', value: 'actions' }
      ],
      actions: [
        { title: 'Show', action: 'doShow', icon: 'mdi-binoculars' },
        { title: 'Download', action: 'doDownload', icon: 'mdi-download' }
      ]
    }
  },
  computed: {
    attachments () {
      return sortBy(prop('updated_at'), this.datasourceMailer.attachments)
    }
  },
  methods: {
    fieldValue (field) {
      return path(split('.', field), this.datasourceMailer)
    },
    fieldName (field) {
      return field.replace(/\./gi, ' ').replace(/_/gi, ' ')
    },
    executeAction (action, item) {
      this[action](item)
    },
    doShow (item) {
      this.$router.push({ name: 'datasource_mailer_attachment_path', params: { datasource_mailer_id: this.$route.params.id, id: item.id } })
    },
    doDownload (item) {
      this.downloadAttachment(this.$route.params.id, item.id)
    }

  },
  mounted () {
    this.fetch(this.$route.params.id)
  }

}
</script>
